import React from 'react';

import { MenuItem } from '@mui/material';
import { Icon } from 'semantic-ui-react';
import { makeStyles } from 'tss-react/mui';

const useCascadingMenuStyles = makeStyles()(() => ({
  menuitem: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'initial',
  },
}));

interface SingleMenuItemProps {
  onClick?: any;
  item: any;
  ohsFormSettings: any;
  id: string;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function OhsOptionWithNoSubMenus(props: SingleMenuItemProps) {
  const { classes } = useCascadingMenuStyles();

  const result = props.ohsFormSettings.useFormMethods.watch(props.id) ?? ([] as string[]);

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLLIElement>) => {
      const newItem = [props.item.name];
      const exists = (result || []).some((arr: any) => {
        return (
          arr.length === newItem.length &&
          arr.every((element: any, index: number) => element === newItem[index])
        );
      });
      if (!exists) {
        const newValues = [...(result || []), newItem];
        props.ohsFormSettings.useFormMethods.setValue(props.id, newValues);
        props.ohsFormSettings.useFormMethods.trigger(props.id);
      }
      props.setOpen(false);
      if (props.onClick) props.onClick(event);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [props.onClick]
  );

  return (
    <MenuItem onClick={handleClick} className={classes.menuitem}>
      {props.item.icon ? <Icon name={props.item.icon} /> : ''}
      <span
        style={{
          whiteSpace: 'pre-wrap',
        }}
      >
        {props.item.name}
      </span>
    </MenuItem>
  );
}

OhsOptionWithNoSubMenus.defaultProps = {
  onClick: undefined,
};

export default OhsOptionWithNoSubMenus;
